<template>
  <div class="relation-list">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>关系管理</span>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="用户ID">
          <el-input v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="relationList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="target_user_id" label="目标用户ID" width="120"></el-table-column>
        <el-table-column prop="relation_type" label="关系类型" width="120">
          <template #default="scope">
            <el-tag :type="getRelationTypeTag(scope.row.relation_type)">
              {{ getRelationTypeText(scope.row.relation_type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.status ? 'success' : 'info'">
              {{ scope.row.status ? '已确认' : '待确认' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RelationList',
  data() {
    return {
      relationList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { user_id: '' }
    }
  },
  mounted() {
    this.fetchRelationList()
  },
  methods: {
    // 获取关系列表
    fetchRelationList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/content/relation-list?page=${this.currentPage}&pageSize=${this.pageSize}&user_id=${this.searchForm.user_id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.relationList = data.data.list
            this.total = data.data.total
          }
        })
      } catch (error) {
        this.$message.error('获取关系列表失败')
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchRelationList()
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchRelationList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchRelationList()
    },

    // 获取关系类型标签
    getRelationTypeTag(type) {
      const tags = {
        1: 'success',
        2: 'warning',
        3: 'info'
      }
      return tags[type] || 'info'
    },

    // 获取关系类型文本
    getRelationTypeText(type) {
      const texts = {
        1: '好友',
        2: '关注',
        3: '拉黑'
      }
      return texts[type] || '未知'
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.relation-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}
</style>
